module.exports = __webpack_public_path__ + "img/压力传感器.e709513c.jpg";